import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

// Components
import NoValidateProducts from "views/wms/task/components/NoValidateProducts";
import CancelledItemList from "./CancelledItemList";
import PickingOrInTrolleyItemList from "./PickingOrInTrolleyItemList";
import {WmsItemsStatus} from "../../../../../../utils/WmsItemsStatus";

RetailerItemsList.propTypes = {
    wmsItems: PropTypes.array.isRequired,
    cancelledItems: PropTypes.array.isRequired,
    itemsToPick: PropTypes.number,
    itemsInTrolley: PropTypes.number,
    itemsCancelled: PropTypes.number,
    filterValue: PropTypes.number,
    onItemClick: PropTypes.func
}

function RetailerItemsList({
    retailerItems,
    wmsItems,
    cancelledItems,
    handleCloseRetailerDrawer,
    itemsInTrolley = 0,
    itemsCancelled = 0,
    filterValue = 0,
    onItemClick = (wmsItem) => {}
}) {
    if (filterValue === 1 && itemsInTrolley === 0 && itemsCancelled === 0) {
        return <NoValidateProducts />
    }

    useEffect(() => {
        if (0 < retailerItems.length && retailerItems.every((item) => WmsItemsStatus.IN_TROLLEY === item.status || WmsItemsStatus.CANCELED === item.status)) {
            handleCloseRetailerDrawer()
        }
    }, [retailerItems, handleCloseRetailerDrawer]);

    return (
        <div>
            <PickingOrInTrolleyItemList
                retailerItems={retailerItems}
                wmsItems={wmsItems}
                onItemClick={onItemClick}
            />
            {filterValue === 1 && itemsCancelled > 0 && (
                <CancelledItemList
                    wmsItems={cancelledItems}
                    itemsCancelled={itemsCancelled}
                    onItemClick={onItemClick}
                />
            )}
        </div>
    )
}

export default RetailerItemsList
